export const timesheetRowsQueryKey = (timesheetId) => ['timesheets', timesheetId, 'rows'];
export const timesheetRowQueryKey = (timesheetId, id) => ['timesheets', timesheetId, 'rows', id];
//# sourceMappingURL=query-key.js.map